import React, {useState, useEffect, useContext} from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';

//import { TextField } from '@mui/material';

const TicketTasks = (props) => {
    const {
        active,
        ticket,
        updateTicketDescription,
        tasksChanged
    } = props;

    const [taskList, setTaskList] = useState([]);
    const [mouseOverIndex, setMouseOverIndex] = useState(-1);

    useEffect(() => {
      if(taskList){
        tasksChanged(taskList) 
      } 
      console.log(taskList)
    }, [taskList, tasksChanged]);

    useEffect(() => {
      if (ticket && ticket?.tasks) setTaskList(ticket.tasks);
      console.log(ticket)
    }, [ticket]);

    const updateMouseOverIndex = (index) => {
      setMouseOverIndex(index)
    }

    const editTask = (code, description, qty, index) => {
      // console.log(`code: ${code}, description: ${description}, qty: ${qty}, index: ${index}`)
      const itemToEdit = taskList[index];
        itemToEdit.description = description ?? itemToEdit.description
        itemToEdit.code = code ?? itemToEdit.code

        
        itemToEdit.additional_qty = qty ?? itemToEdit.additional_qty
        var total = itemToEdit?.init_qty + itemToEdit.additional_qty
        if (total < 0) {
          itemToEdit.additional_qty = -itemToEdit.init_qty
        }
        
        console.log(itemToEdit)
        taskList.splice(index, 1, itemToEdit);
        setTaskList([...taskList])
    }

    const deleteTask = (index) => {
      taskList.splice(index, 1);
        setTaskList([...taskList]);
    }
    
    const addRow = () =>{
      const newTask = {
        ticket_task_id: null,
        action: null,
        code: null,
        date_completed: null,
        description: null,
        family: null,
        task_id: null,
        type: null,
        uom: null, 
        init_qty: null,
        additional_qty:1
      };

      if(JSON.stringify(taskList[0]) === JSON.stringify(newTask)) {
        // console.log(`already have new empty task return`)
        return
      }
      setTaskList([newTask, ...taskList])
    }

    return (
        <div className={`tab-pane fade${active ? ' show active' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">  
          {/* section - Description / Groups */}
          {/* {console.log(taskList)} */}
          <div className="row flex-column section descriptionGroups">
            
            {/* section - Description */}
            <div className={`col-12 d-flex flex-column item description`}>
              <label className="label labelTitle" htmlFor="exampleFormControlTextarea1">Description</label>
              <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={ticket?.description ? ticket.description : ''} onChange={(e)=>updateTicketDescription(e.target.value)} />
            </div>
    
          <Table className="table table-striped" onMouseLeave={() => updateMouseOverIndex(-1)}>
            <Thead>
              <Tr>
                <Th scope="col" ><label>Task Code</label></Th>
                <Th scope="col"><label>Task Description</label></Th>
                <Th scope="col"><label>Initial Quantity</label></Th>
                <Th scope="col"><label>Actual Quantity</label></Th>
                <Th scope="col"><button onClick={() => addRow()}>Add Task</button></Th>
              </Tr>
            </Thead>
            <Tbody>
              {
                taskList.map((task, index) => {
                  return (
                    
                    <Tr key={ "tasksa" + index } onMouseEnter={() => updateMouseOverIndex(index)} className="clickable-row">
                       <div style={{display:'none'}}>
                          Task ID: { task?.ticket_task_id }
                        </div>
                        <Td scope="row">{!task?.ticket_task_id ? 
                                            <input 
                                                key={index + 'code' + taskList?.length}  
                                                value={task?.code ?? ''} 
                                                onChange={(e) => editTask(e.target.value, null, null, index) }>
                                                </input> 
                                            : task.code}</Td>
                        <Td scope="row">{!task?.ticket_task_id ? 
                                            // <TextField
                                            <input
                                                key={index + 'descr' + taskList?.length} 
                                                value={task?.description ?? ''} 
                                                onChange={(e) => editTask(null, e.target.value, null, index) }>
                                                </input> 
                                            : task.description}</Td>
                        <Td scope="row">{task?.init_qty ?? 0}</Td>
                        <Td scope="row"> 
                          { task?.ticket_task_id ?
                            <input 
                                key={index + 'addqty' + taskList?.length}
                                //disabled={mouseOverIndex !== index}
                                id="outlined-number"
                                type="number"
                                value= { task?.additional_qty ?? '' }
                                variant="outlined"
                                onChange={ (e) => editTask(null, null, Number(e.target.value), index) }>
                                </input>
                          : "" 
                          }
                        </Td>
                        { 
                        <Td scope="row">
                          {mouseOverIndex === index &&
                            <button onClick={(e)=> {deleteTask(index)}}>Delete</button>
                          }
                        </Td>
                        }
                    </Tr>
                  )
                })
              }

            </Tbody>
          </Table>
        </div>
        {/* section - Pole radios */}
        {/* <Section className="formContents"></Section> */}
        </div>
    )
}

export default TicketTasks